class arrived {
  constructor(data) {
    const sessionUser = JSON.parse(sessionStorage.getItem("user"));
    this.items = {
      id: 30001,
      name: "Start Text",
      type: "text",
      slideimg: "/doctorassistant/dia.jpg",
      options: [
        {
          id: 40012,
          text: "YES",
          name: "YES",
          price: "",
          type: "feedback",
          desc: "YES",
          key:'is_fixed',
          value:1
        },
        {
          id: 40012,
          text: "No, He is still working",
          name: "No, He is still working",
          price: "",
          type: "stillworking",
          desc: "No, He is still working",
        },
        {
          id: 40012,
          text: "He Could not fix it",
          name: "He Could not fix it ",
          price: "",
          type: "notfixed",
          desc: "He Could not fix it",
          key:'is_fixed',
          value:0

        },
      ],
      backtostart: false,
      text: [`<p>Is your vehicle fixed</p> `],
    };
  }

  getAllItems() {
    return this.items;
  }
}

export default arrived;
